<template>
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.ClientInventory')" :categoryIcon="'scf-patrimoine'"
      :title="$t('sideMenu.PatrimoineList')" />
    <div style="max-width: 100%">
      <div class="row" style="
          align-content: flex-end;
          justify-content: flex-end;
          padding-top: 10px;
        "></div>
      <div class="row">
        <div class="col-md-12" v-if="componentKey > 0">
          <OdataFlexGrid :key="componentKey" :Api="{
            base: urlOdata + 'api/v1/OData/',
            controller: 'Assets'
          }" :requestHeaders="gridHeaders" :FiltersDefinition="FiltersDefinition" :ColumnsDefinition="columns"
            :FilterColumns="[
              'ClientIdentifier',
              'ServicePointIdentifier',
              'HourlyConsent',
              'TransmitterIdentifier',
              'TransmitterAlternateIdentifier',
              'TransmitterInstallingDate',
              'RadioMode',
              'SensorIdentifier',
              'MeterDiameterInMillimeter',
              'Accessibility',
              'MeasurementStepType',
              'SensorInstallDate',
              'Source',
              'HasPairing',
              'Version'
            ]" :displayLang="culture" v-on:initializedGrid="gridInitialized" v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'patrimoineGrid-v9'" :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')" v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="componentKey++" />
          <!-- END Grid -->
        </div>
        <loaderSpinner :loading="isLoading"></loaderSpinner>
        <p></p>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import Helper from "@/Utils/Helper";
import "sweetalert2/dist/sweetalert2.min.css";
import Configs from "../../configs";
import * as wjcGrid from "@grapecity/wijmo.grid";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
import LoaderSpinner from "../components/LoadingSpinner.vue";

export default defineComponent({
  name: "CompaignList",
  inject: ["accessToken", "routePrefix", "currentScope"],
  components: {
    OdataFlexGrid,
    ContentTitle,
    LoaderSpinner,
  },

  watch: {
    currentScope: {
      handler: function (newVal) {
        if (newVal) {
          this.currentScopeView = newVal;
          this.isPreselectedScope = false;
          this.mainService = new MainService(this.$jwt.token, newVal);
          this.componentKey += 1;
        }
      },
      deep: true
    },
    preselectedScope(newVal) {
      if (newVal) {
        console.log("PreselectedScope changed: ", newVal);
        this.mainService = new MainService(this.$jwt.token, newVal);
        this.componentKey += 1;
      }
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.isPreselectedScope ? this.preselectedScope : this.currentScopeView);
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== '')
        this.componentKey += 1;
    }
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': computed(() => this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
        'X-Custom-Filters': computed(() => this.headerFilters),
      },
      isLoading: false,
      componentKey: 0,
      isPreselectedScope: false,
      preselectedScope: null,
      preselectedFilters: {},
      mainService: new MainService(this.$jwt.token, this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
      config: Configs,
      isFirstLoad: true,
      theGrid: null,
      culture: computed(() => this.$i18n.locale),
      screenName: computed(() => this.$t('sideMenu.PatrimoineList')),
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      currentScopeView: '',
      FiltersDefinition: [
        {
          binding: "Version",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ClientIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "ServicePointIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "HourlyConsent",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Yes",
              label: computed(() => this.getFilterValuesTraduction("Yes", "YesOrNo")),
            },
            {
              id: "No",
              label: computed(() => this.getFilterValuesTraduction("No", "YesOrNo")),
            }
          ],
        },
        {
          binding: "TransmitterIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterAlternateIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "TransmitterInstallingDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "SensorInstallDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "RadioMode",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "1G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.1G")
              ),
            },
            {
              id: "2G",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.2G")
              ),
            },
            {
              id: "G3BIRDZ",
              label: computed(() =>
                this.tryGetTranslation("RadioProtocols.G3BIRDZ")
              ),
            }
          ],
        },
        {
          binding: "SensorIdentifier",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "MeterDiameterInMillimeter",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "HasPairing",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Yes",
              label: computed(() => this.getFilterValuesTraduction("Yes", "YesOrNo")),
            },
            {
              id: "No",
              label: computed(() => this.getFilterValuesTraduction("No", "YesOrNo")),
            }
          ],
        },
        {
          binding: "Accessibility",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Yes",
              label: computed(() => this.getFilterValuesTraduction("Yes", "YesOrNo")),
            },
            {
              id: "No",
              label: computed(() => this.getFilterValuesTraduction("No", "YesOrNo")),
            }
          ],
        },
        {
          binding: "MeasurementStepType",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Daily",
              label: computed(() => this.getFilterValuesTraduction("Daily", "MeasurementStepType")),
            },
            {
              id: "DailyAndHourly",
              label: computed(() => this.getFilterValuesTraduction("DailyAndHourly", "MeasurementStepType")),
            },
            {
              id: "DailyAnd15m",
              label: computed(() => this.getFilterValuesTraduction("DailyAnd15m", "MeasurementStepType")),
            },
            {
              id: "DailyAnd6h",
              label: computed(() => this.getFilterValuesTraduction("DailyAnd6h", "MeasurementStepType")),
            },
            {
              id: "CompressedDailyAndHourly",
              label: computed(() => this.getFilterValuesTraduction("CompressedDailyAndHourly", "MeasurementStepType")),
            }
          ],
        },
        {
          binding: "Source",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Manufacturer",
              label: computed(() => this.getTraductionTransactionSource("Manufacturer")),
            },
            {
              id: "Mobility",
              label: computed(() => this.getTraductionTransactionSource("Mobility")),
            },
            {
              id: "Manual",
              label: computed(() => this.getTraductionTransactionSource("Manual")),
            },
            {
              id: "Assets",
              label: computed(() => this.getTraductionTransactionSource("Assets")),
            },
            {
              id: "Cancelation",
              label: computed(() => this.getTraductionTransactionSource("Cancelation")),
            }

          ],
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      ManufacturersSource: null,
      loading: true,
      startLoadingTime: 0,
      rowsCount: 0,
      columns: [
        {
          width: "80*",
          header: computed(() => this.$t("pages.ClientInventory.columns.Id")),
          binding: "Id",
          dataType: 2,
          visible: false,
          isTechnicalColumn: true,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.ClientIdentifier")
          ),
          binding: "ClientIdentifier",
          dataType: 1,
          visible: false,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.ServicePointIdentifier")
          ),
          binding: "ServicePointIdentifier",
          dataType: 1,
          iconClass: "scf-patrimoine",
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.Version")
          ),
          binding: "Version",
          dataType: 1,
        },
        {
          width: "60*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.HourlyConsent")
          ),
          binding: "HourlyConsent",
          dataType: 1,
          iconClass: "scf-patrimoine",
        },

        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.TransmitterIdentifier")
          ),
          binding: "TransmitterIdentifier",
          dataType: 1,
          iconClass: "scf-transmitter-v2",
        },
        {
          width: "50*",
          header: computed(() =>
            this.$t("pages.FirmwareList.columns.Source")
          ),
          binding: "Source",
          dataType: 1,
          visible: true,
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t(
              "pages.ClientInventory.columns.IdentifiantAlternatifEmetteur"
            )
          ),
          binding: "TransmitterAlternateIdentifier",
          dataType: 1,
          iconClass: "scf-transmitter-v2",
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.InstallDate")
          ),
          binding: "TransmitterInstallingDate",
          dataType: 4,
          iconClass: "scf-transmitter-v2",
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.RadioMode")
          ),
          binding: "RadioMode",
          dataType: 1,
          iconClass: "scf-transmitter-v2",
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.IdentifiantCompteur")
          ),
          binding: "SensorIdentifier",
          dataType: 1,
          iconClass: "scf-sensor",
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.MeterDiameterInMillimeter")
          ),
          binding: "MeterDiameterInMillimeter",
          dataType: 1,
          iconClass: "scf-sensor",
        },
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.Accessibility")
          ),
          binding: "Accessibility",
          dataType: 1,
          iconClass: "scf-sensor",
        },
        {
          width: "50*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.MeasurementStepType")
          ),
          binding: "MeasurementStepType",
          dataType: 1,
          visible: true,
        },
        {
          width: "50*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.SensorInstallDate")
          ),
          binding: "SensorInstallDate",
          dataType: 4,
          visible: true,
        },
        {
          width: "20*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.TransmitterId")
          ),
          binding: "TransmitterId",
          dataType: 2,
          visible: false,
          isTechnicalColumn: true,
        },
        {
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.ServicePointId")
          ),
          binding: "ServicePointId",
          dataType: 2,
          visible: false,
          isTechnicalColumn: true,
        },
        {
          width: "20*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.SensorId")
          ),
          binding: "SensorId",
          dataType: 2,
          visible: false,
          isTechnicalColumn: true,
        },
        {
          width: "50*",
          header: computed(() =>
            this.$t("pages.ClientInventory.columns.pairing")
          ),
          binding: "HasPairing",
          dataType: 1,
          visible: true,
        },
      ],
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") + "api/v1/OData/Assets/export?",
    };
  },
  methods: {
    filterReference: function () {
      if (this.preselectedFilters != {}) {
        let gridFilter = "";
        Object.keys(this.preselectedFilters).forEach((key) => {
          gridFilter += `(${key} eq '${this.preselectedFilters[key]}')`
        });
        this.theGrid.collectionView.filterDefinition = gridFilter;
      }
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    getTraductionTransactionSource: function (e) {
      return this.tryGetTranslation(`pages.DeviceImportList.Source.${e}`);
    },
    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel`;
      }


      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(this.screenName, type, "xlsx", response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv`;
      }

      console.log(exportUrl);
      this.isLoading = true;
      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes(this.screenName, type, "csv", response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(reportName, byte) {
      var blob = new Blob([byte], { type: "application/vnd.ms-excel" });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      var fileName = reportName;
      link.download = fileName;
      link.click();
    },
    gridInitialized(flexgrid) {
      this.theGrid = flexgrid;
      this.filterReference();

      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type");
        if (!action) {
          return;
        }
      });
    },
    formatColumns: function (s, e) {
      const flex = s;
      const prefix = Helper.ComputeRoutePrefix(this.routePrefix);

      if (e.panel == flex.cells) {
        const scope = this.isPreselectedScope ? this.preselectedScope : this.currentScopeView;
        if (flex.rows[e.row].dataItem.name) return;
        if (flex.columns[e.col].binding == "Source") {
          const translatedText = this.$t("pages.DeviceDetails.DeviceSources." + s.rows[e.row].dataItem.Source);
          e.cell.innerHTML = s.rows[e.row].dataItem.Source ?
            translatedText.includes('.') ? s.rows[e.row].dataItem.Source : translatedText
            : '';
        }
        if (flex.columns[e.col].binding == "SensorIdentifier") {
          e.cell.innerHTML = s.rows[e.row].dataItem.SensorIdentifier ?
            `<a target="_blank" style="color:#6095D6;text-decoration: none;" href="${prefix}/DmPortal/equipmentdetail/${scope}/Sensor/${s.rows[e.row].dataItem.SensorId}">${s.rows[e.row].dataItem.SensorIdentifier}</a>`
            : '';
          console.log("the sensor id: ", s.rows[e.row].dataItem);
        }
        if (flex.columns[e.col].binding == "TransmitterIdentifier") {
          e.cell.innerHTML = s.rows[e.row].dataItem.TransmitterIdentifier ?
            `<a target="_blank" style="color:#6095D6;text-decoration: none;" href="${prefix}/DmPortal/equipmentdetail/${scope}/Transmitter/${s.rows[e.row].dataItem.TransmitterId}">${s.rows[e.row].dataItem.TransmitterIdentifier}</a>`
            : '';

        }
        if (flex.columns[e.col].binding == "TransmitterAlternateIdentifier") {
          e.cell.innerHTML = s.rows[e.row].dataItem.TransmitterAlternateIdentifier ?
            `<a target="_blank" style="color:#6095D6;text-decoration: none;" href="${prefix}/DmPortal/equipmentdetail/${scope}/Transmitter/${s.rows[e.row].dataItem.TransmitterId}">${s.rows[e.row].dataItem.TransmitterAlternateIdentifier}</a>`
            : '';
        }
        if (flex.columns[e.col].binding == "ServicePointIdentifier")
          e.cell.innerHTML = s.rows[e.row].dataItem.ServicePointIdentifier ?
            `<a target="_blank" style="color:#6095D6;text-decoration: none;" href="${prefix}/DmPortal/equipmentdetail/${scope}/Asset/${s.rows[e.row].dataItem.ServicePointId}">${s.rows[e.row].dataItem.ServicePointIdentifier}</a>`
            : '';
        if (flex.columns[e.col].binding == "HasPairing") {
          e.cell.innerHTML = this.$t(`common.${s.rows[e.row].dataItem.HasPairing}`);
        }
      }

    },
    formatGrid: function (s, e) {
      if (
        s.columns[e.col].header == "Action" &&
        e.panel.cellType == wjcGrid.CellType.Cell
      ) {
        e.cell.innerHTML =
          '<i class="scf-search" style="cursor:pointer"><a href="#"></a></i>';
      }
    },
    getFilterValuesTraduction: function (key, param) {

      if (!utils.isNotFound(this.$t(((("pages.ClientInventory.FilterValues").concat(".", param)).concat(".", key)))))
        return this.$t(((("pages.ClientInventory.FilterValues").concat(".", param)).concat(".", key)));
      return key;
    },
    fillPreselectedFilters() {
      const devicetype = this.$route.params["deviceType"];
      if (devicetype && devicetype.length > 0) {
        const deviceTypeKey = devicetype == "Asset" ? "ServicePointIdentifier" : `${this.$route.params["deviceType"]}Identifier`;
        this.preselectedFilters[deviceTypeKey] = this.$route.params["externalId"];
      }
    },
  },
  created() {

    const preselectedScope = this.$route.params["scope"];
    if (this.currentScopeView != null) {
      this.isPreselectedScope = false;
      this.componentKey++;
    } else if (preselectedScope) {
      if (preselectedScope && preselectedScope.length > 1) {
        this.fillPreselectedFilters();
        this.isPreselectedScope = true;
        this.preselectedScope = preselectedScope;
      }
    } else {
      this.currentScopeView = this.currentScope ?? this.$jwt.scope;
      this.componentKey++;
    }
  },
});
</script>

<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}
</style>

<style scoped src="../assets/css/campaignList.css"></style>
